import * as lightbox from '#utilities/js/lightboxes/lightbox.js'
import * as utilities from '#utilities/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import keyDown from '@mailobj-browser/front/js/events/types/keyDown.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { elements } from '../styles.js'

const keys = {
  async Enter (
    item,
    event
  ) {
    const anchorModal = one(`.${elements.anchor}`, item)
    
    if (anchorModal) {
      const { ownerDocument } = anchorModal
      const container = one(`.${utilities.elements.aside_lightboxes}`, ownerDocument)
      const template = one('template', anchorModal)

      await lightbox.open(template, container, anchorModal, true)
    }
  }
}

const onKeyDown = object(listener, {
  type: keyDown,
  task: async (
    item,
    event
  ) => {
    const { defaultPrevented, key } = event

    if (defaultPrevented) {
      return
    }

    await keys[key]?.(item, event)
  }
})

export default (
  item
) => {
  onKeyDown.listen(item)
}
